import React, { useState, useEffect, useRef } from 'react';
import Progress from './Progress';

import Property from './Property';
import { makeStyles } from '@material-ui/core/styles';
import './dnd.css'
import TaskAnnotations from './TaskAnnotations';
import getQueryParam from './Query'; 
import Modal from 'react-bootstrap/Modal';
// import Button from 'react-bootstrap/Button';
import recorder from '../img/recorder.png';
import help from '../img/help.png';
import loaddisk from '../img/load.png';
import cloudupload from '../img/cloud-upload.png';

import softdownload from '../img/soft-download.png';

import getNodeType from './NodeTypes'; 
import Dialog from './Dialog';
import {apiPost,apiGet, apiPut} from "../apis/apiUtils";
import AddEmail from './AddEmail';
import {LightTooltip} from './LightTooltip';
import { Box } from '@material-ui/core';
import Loading from './Loading';
import IconButton from "@material-ui/core/IconButton";
import BotLoadIcon from '@material-ui/icons/FolderOpenOutlined';
import DownloadIcon from '@material-ui/icons/CloudDownload';
import HelpIcon from '@material-ui/icons/Help';
import Button from '@material-ui/core/Button';

import CloudUploadIcon from '@material-ui/icons/CloudUpload';

import ReactFlow, {
    ReactFlowProvider,
    addEdge,
    removeElements,
    getOutgoers,
    Controls, MiniMap, Background
  } from 'react-flow-renderer';  

  import BizNode from './BizNode';
  import IfNode from './IfNode';
  import LoopNode from './LoopNode';
  import MouseNode from './MouseNode';
  import FileNode from './FileNode';
  import WaitNode from './WaitNode';
  import BotNode from './BotNode';
  import CallNode from './CallNode';
  import RESTNode from './RESTNode';
  import KeyNode from './KeyNode';
  import RegularNode from './RegularNode';
  import SpeakerNode from './SpeakerNode';
  import SpeechToTextNode from './SpeechToTextNode';
  import ScreenActivityNode from './ScreenActivityNode';  
  import BrowserNode from './BrowserNode';
  import nodeStyles from './nodeStyles';
  import message from './message';
  import customConnectionLine from './customConnectionLine';
  import getFields from './ActionFields';
  
  import ButtonEdge from './ButtonEdge';
  
  import { save } from 'save-file';

  import secondsToMin from './Util';
import FileSaver from 'file-saver';
  
  const edgeStyle = {
    // stroke: '#9999ff',
    strokeWidth:1.7,
    // strokeOpactiy:0.1

  };




// const initialElements = [
//     {
//       id: '1',
//       type: 'input',
//       data: { label: 'Screen Flow' },
//       position: { x: 800, y: 50 },
//       style: {
//         background: 'steelblue',
//         color: 'white',
//         border: '1px solid #222138',
//         borderTopRightRadius:30,
//         borderTopLeftRadius:30,
//         borderBottomRightRadius:30,
//         borderBottomLeftRadius:30,
//         width: 200,
//       },
//     }
  
//   ];


  // const genericNodeStyle = {
  //   background: 'skyblue',
  //   color: 'blue',
  //   // border: '1px solid #222138',
  //   width: 50,
  //   height: 50,
    
  // };
  
  // let nodeStyle = genericNodeStyle;
  let id = 3;
  const getId = () => `dnd_${id++}`;

  


export default function VisualizeFlow(props)
{

  const nodeStyle = {
      // background: '#9999ff',
      background: 'white',
      // background: '#649cdc',
      border:'1px solid lightgrey',
      borderRadius:'5px',
      color: 'grey',
      
    };

  

  const [fromElement, setFromElement] = useState(1)
  const [selectedElement, setSelectedElement] = useState(null)
  const [elements, setElements] = useState([]);
  const [numScreens, setNumScreens] = useState(0);
  const [appFromElement, setAppFromElement] = useState(null)
  const [appElements, setAppElements] = useState([]);

  const [totalTime, setTotalTime] = useState(0);

  const [show, setShow] = useState(false);
  const [showEmail, setShowEmail] = useState(false);

  const [mostTimeSpent, setMostTimeSpent] = useState(0)
  const [mostTimeSpentApp, setMostTimeSpentApp] = useState('')

  const [appHops, setAppHops] = useState(0)

  const [appTimeMap, setAppTimeApp] = useState(new Map())
  const [appSet, setAppSet] = useState(new Set());

  const [bots, setBots] = useState([])
  const [recordingName, setRecordingName] = useState([])

  const [fileMap, setFileMap] = useState(new Map())
  const [dataURLs, setDataURLs] = useState(new Map())

  const [submission, setSubmission] = useState({})
  const [loading, setLoading] = useState(false)

  const [progress, setProgress] = useState(1)
  const [showProgress, setShowProgress] = useState(false)
    
  const[uploadStatus, setUploadStatus] = useState("") 
  const[firstTime, setFirstTime] = useState(true)

  var id = getQueryParam('id') 
  console.log('id '+id);
  
  var url = `${process.env.REACT_APP_API_PREFIX}/processdiscovery/getSubmissionById/` + id;
  var isReady = false;

  const record = () =>
  {
    const requestOptions = {
      method: 'GET',
      // headers: { 'Content-Type': 'application/json'}
    }
  
    // fetch('http://localhost:' + localStorage.getItem('agentPort') + '/v1/bots/execute/recorder' , requestOptions)
    // .catch(error => {alert(error)});
    window.open('autosmic-recorder://')

    
  }

  const helpLink = () =>{
    window.open('https://www.youtube.com/watch?v=NYROU5Ah9nk&list=PLUY5xJNivcMjGPrN-m2w3e6KPXIyFUxmj', "_blank")
    
  }

    const clearElements = (elementsToRemove)=>
    {
      if (elementsToRemove == null) return
      if (elementsToRemove.length == 0){return}
      
      onElementsRemove(elementsToRemove)


    }
    const onElementsRemove = (elementsToRemove) =>
    setElements((els) => removeElements(elementsToRemove, els));


    const loadModel = (botname, content) => {
      if ( elements.length == 0 ) {
        var initNode = 
        {
          id: '1',
          type: 'input',
          data: { label: 'Screen Flow' },
          position: { x: 800, y: 50 },
          style: {
            background: 'royalblue',
            color: 'white',
            border: '1px solid grey',
            borderTopRightRadius:30,
            borderTopLeftRadius:30,
            borderBottomRightRadius:30,
            borderBottomLeftRadius:30,
            width: 200,
          },
        }
    
        setElements((es) => es.concat(initNode));

      }
      else {
      clearElements(elements.slice(1))
      }
      setSelectedElement(elements[0])
      setFromElement('1')
      lastPosition = { x:600, y:50}
      const events = JSON.parse(content)
      var sourceElement = '1'
      var index=0
      var increment = 200  
      var lastType=''

      events.map(item => {
          var id = getId()
          var skip = false
          var position = {x:lastPosition.x , y: lastPosition.y + increment}
          var name = item["py/object"]
          var ind1 = name.indexOf('.')
          var ind = name.lastIndexOf('Event')
          name = name.substring(ind1+1, ind)
          const type = getNodeType(name)
          // console.log(type)  
          var screenImage = ''
          var clickImage = ''
          var nodeType = type
          var screenAttributes = {}
          var attributes = {}
          if (type.startsWith('Key')  || type.startsWith('Text') || name == "HotKey" || name.startsWith("Key"))
          {
            skip = true

            // if (lastType=='Key')
            // skip = true
            // else {
            //   lastType = 'Key'
            // }
  
          }
          else  {
            skip = false
            lastType = type
          }
          if ( type == 'MouseNode' && item["command"] == 'release')
          {skip = true}
          if ( type == 'MouseNode' && item["command"] == 'scroll')
          {skip = true}
          if ( type == 'MouseNode' && item["command"] == 'move')
          {skip = true}
          if ( name == 'MouseDrag')
          {skip = true}
          if ( type == 'WaitNode')
          {skip = true}

          screenAttributes = {}


          if (!skip)
          {
            attributes = item
          if ( type == 'MouseNode')
          {
            if (item["command"] == 'press')
            {
              screenImage = 'screen' + index + '.png'
              clickImage = index + '.png'
              nodeType = 'ScreenActivityNode'
              if (item.screenAttributes == undefined || item.screenAttributes == null){
                screenAttributes = getFields("ScreenActivity")
                // attributes = screenAttributes 
              }
              else screenAttributes = item.screenAttributes
              { increment = 700}

              index = index + 1
            }
          }
          else{ 
            screenImage = ''
            increment = 200
          } 

          const screenData = dataURLs.get(screenImage)
          // console.log(screenData)
          const imageData = dataURLs.get(clickImage)

          const appAttributes = getFields("ScreenActivity")
          const newNode = {
            id: id,
            type:nodeType,
            position,
            style:nodeStyle, 
            data: { label: name, "attributes":attributes, type:type, entity:botname, screenImage:screenImage, screenAttributes:screenAttributes, screenImageData:screenData, clickImageData:imageData}
          };

          setElements((es) => es.concat(newNode));

          if ( sourceElement != null)
          {
            const edgeId = fromElement + '-' + id

            const newEdge = 
            {
              id: edgeId,
              source: sourceElement,
              style:{strokeWidth:3.0},
              target: id,
              type:'step',
              arrowHeadType: 'arrow',
            }
            
            setElements((es) => es.concat(newEdge));
          }

          sourceElement = newNode.id          
          lastPosition = position
        }
      


    });
    setFromElement(sourceElement)
    setNumScreens (index)
    console.log("Setting first time to false")
    setFirstTime(false)
    return true;

  }


  const loadAppJSON = (content)=>{
      lastPosition = { x:50, y:50}
      const events = JSON.parse(content)
      var sourceElement = null;

      var elementBuffer = []
      var increment = 150  
      var totalTime = 0
      var mostTime = 0
      var mostApp = ''
      setAppHops(events.length)

      events.map(item => {
          var id = getId()
          var position = {x:lastPosition.x , y: lastPosition.y + increment}
          const type = "AppNode"
          
          totalTime = totalTime + item.timeSpent
          var value = appTimeMap.get(item.shortApp)
          if (value == null) {
            appTimeMap.set(item.shortApp, item.timeSpent)
            if (mostTime < item.timeSpent){
              mostTime= item.timeSpent
              mostApp = item.shortApp
            }
            // console.log("setting map " + item.shortApp)

          }
          else{
            value = value + item.timeSpent
            appTimeMap.set(item.shortApp, value)
          }
          appSet.add(item.shortApp)
          const newNode = {
            id: id,
            type,
            position,
            style:nodeStyle, 
            data: { appName:item.app, appShortName:item.shortApp, appType:item.appType, timeSpent:item.timeSpent}
          };
          // elementBuffer.add(newNode)
            setAppElements((es) => es.concat(newNode));
          // console.log(newNode)

          if ( sourceElement != null)
          {
            const edgeId = appFromElement + '-' + id

            const newEdge = 
            {
              id: edgeId,
              source: sourceElement,
              style:{strokeWidth:3.0},
              target: id,
              type:'step',
              arrowHeadType: 'arrow',
            }
            
            // elementBuffer.add(newEdge)
            setAppElements((es) => es.concat(newEdge));
          }

          sourceElement = newNode.id          
          lastPosition = position
        }


    );

    setAppFromElement(sourceElement)
    setTotalTime(totalTime)
    setAppSet(appSet)

    // console.log(appTimeMap)
    setMostTimeSpentApp(mostApp)    
    setMostTimeSpent(mostTime)    
    
  }



  const upload = () =>{
    if (document.getElementById('timesaday').value == "") 
    {
      alert("Please set the numerical value for: Number of times task is done per day")
      return
    }
    // setShowEmail(true)
    var requestOptions = {
      method: 'GET',
      // mode:'no-cors',
      // headers: { 'Content-Type': 'text/plain'}
    }

    // ** get upload urls ***
    url = `${process.env.REACT_APP_API_PREFIX}/storagemanagement/generateUploadPresignedUrlListBySubmissionId`;

    var filesToBeUploaded=""

    // TODO: check f map has any files to upload
    for (let [key, value] of fileMap) {
      // console.log(key + " = " + value);
      filesToBeUploaded = filesToBeUploaded.concat(',', key)
    }

    filesToBeUploaded = filesToBeUploaded.slice(1)
    console.log("Files to be uploaded: " + filesToBeUploaded)
    
    var body= {
      "submissionId" : id ,
      "fileNameDelimitedList" : filesToBeUploaded
    }

    setProgress(2)
    setUploadStatus("In Progress")
    setShowProgress(true)
    var urls
    requestOptions = {
      method: 'POST',
      body:JSON.stringify(body),
      headers: { 'Content-Type': 'text/plain'},
      // headers: { 'Content-Type': 'text/plain', 'Authorization': 'Bearer ' + sessionStorage.getItem('TOKEN')}
      // body:JSON.stringify(body)
    }

    fetch(url , requestOptions)
    .then (async response => {
      const data = await response.text();
      // console.log(data)
      if (!response.ok) 
      {
        const error = (data && data.message) || response.status;
        console.log(error)
        return Promise.reject(error);

      }
      console.log(data)
      urls = JSON.parse(data)
      console.log(urls)
      var list = urls.data.preSignedUrList

      setProgress(10)
    // **Upload files ***

      var numFiles = list.length 

      for (var index = 0; index < numFiles; index ++ ){
        var fileName = list[index].fileName
        
        // if (fileName.endsWith('.json')){


        var uploadURL = list[index].url
        // content type needs to be picked
        var contentType = list[index].contentType
        console.log(fileName)
        console.log(contentType)

        body = fileMap.get(fileName)
        // var isBin = false
        // if (fileName.includes('.png')) isBin = true
        console.log("uploading url: "  + uploadURL)
        await apiPut(uploadURL, body, contentType)

        setProgress( (index+1)/numFiles * 100)
      // }
      }

      // setProgress(95)

      // update status of submission to 'Submitted'
      body={
        submissionId:id,
        status: 'Submitted',
        // timeTaken:secondsToMin(totalTime),
        timeTaken:Math.floor(totalTime).toString(),
        numScreens:numScreens.toString(),
        frequency: document.getElementById('timesaday').value,
        submissionDate: Date()

      }
      requestOptions = {
        method: 'POST',
        // headers: { 'Content-Type': 'application/json'}
        body: JSON.stringify(body)
      }
  
      url = `${process.env.REACT_APP_API_PREFIX}/submission/updateSubmission`;
      await fetch(url, requestOptions)
      .then (async response => {
        const data = await response.json();
        // console.log(data)
        if (!response.ok) 
        {
          const error = (data && data.message) || response.status;
          console.log(error)
          // alert(error)
          alert("An error occured. If this persists, please contact your administrator/suport contact for Autosmic")
          return Promise.reject(error);
  
        }
        setProgress(100)
        setUploadStatus("Completed!")

        // alert("Submission completed")

        if (data.result == 'failure')
        alert(data.message)
        setFirstTime(true)

        console.log(data)  
      })

      .catch(error => {
        // alert(error)
        alert("An error occured. If this persists, please contact your administrator/support contact for Autosmic")
      });

      waitFor(2000).then(() => {setShowProgress(false)})
      



    })

    .catch(error => {
      alert("An error occured. If this persists, please contact your administrator/suport contact for Autosmic")
      // alert(error)
    })
    .finally(() =>{
      setShowProgress(false)
    });


  }

  const handleClose = ()=>{
      setShow(false)
  }


  
  const renderBots = ()=>{
      
      return bots.map(bot => {
          return (
          <option value={bot}>{bot}</option>
          )

      });
      
  }

  const clearCanvas = ()=>{
    
  }

  const clickInput = () =>{
    document.getElementById('file-upload').click()
    // setLoading(true)
  }

  const downloadLink = ()=>{
    window.open(
      "https://autosmic-downloads.s3.us-west-1.amazonaws.com/consumer/index.html", "_blank");
  }




  const toolbar = ()  =>
  {
    return (
    <div className='toolbarSubmission'>


    <LightTooltip title="Download Recorder Software"> 
        <IconButton className='toolbutton right' onClick={downloadLink}>
          <DownloadIcon fontSize="medium" />
        </IconButton>
      </LightTooltip>

   <LightTooltip title="Help Videos"> 
    <IconButton className='toolbutton right' onClick={helpLink}>
        <HelpIcon fontSize="medium" />
        </IconButton>

        </LightTooltip>

    </div>
    );

  }
















  const toolbarOld = ()  =>
  {
    return (
    <div className='toolbar'>

    {/* <LightTooltip title="Launch Recorder"> 
        <button className='toolbutton' onClick={record}><img  src={recorder}></img></button>
        </LightTooltip> */}

    <LightTooltip title="Download Recorder Software"> 
        <button className='toolbutton' onClick={downloadLink}><img  src={softdownload}></img></button>
        </LightTooltip>


        <LightTooltip title="Load Recording from local disk"> 
        {/* <button for="file-upload" className='toolbutton' onClick={showModal}><img  src={loaddisk}></img></button> */}
        <button className='toolbutton' onClick={clickInput} ><img  src={loaddisk}></img></button>
        </LightTooltip>


        <LightTooltip title="Submit Recording to Cloud Storage"> 
        <button className='toolbutton' onClick={upload}><img src={cloudupload}></img></button>
        </LightTooltip>

    <LightTooltip title="Help Videos"> 
        <button className='toolbutton' onClick={helpLink}><img  src={help}></img></button>
        </LightTooltip>

    </div>
    );

  }





    var lastPosition = { x:250, y:50}

    const onElementClick = (event, element) => {
      event.preventDefault();
      console.log("Click")
      setSelectedElement(element)
  }

    
  
    const reactFlowWrapper = useRef(null);
    const [reactFlowInstance, setReactFlowInstance] = useState(null);

    const onLoad = (_reactFlowInstance) =>
      setReactFlowInstance(_reactFlowInstance);
  
    const updateProperties = (properties) => {
        selectedElement.data.attributes = properties

    }


    const nodeTypes = {
      BizNode: BizNode,
      IfNode:IfNode,
      LoopNode: LoopNode,
      MouseNode:MouseNode,
      FileNode:FileNode,
      // KeyNode:KeyNode,
      BotNode:BotNode,
      CallNode:CallNode,
      RESTNode:RESTNode,
      WaitNode:WaitNode,
      BrowserNode:BrowserNode,
      SpeakerNode:SpeakerNode,
      SpeechToTextNode:SpeechToTextNode,
      RegularNode:RegularNode,
      ScreenActivityNode:ScreenActivityNode,
    };


 
        
    const renderMain = () => {
      return (
      <div style={ (firstTime == true)? {display:'none'}: {display:'flex'}}>
      <ReactFlow
      style={style}
      elements={elements}
      connectionLineComponent={customConnectionLine}
      nodeTypes={nodeTypes}
      onLoad={onLoad}
      onElementClick={onElementClick}
      onlyRenderVisibleElements={true}
      nodesDraggable={false}
      panOnScroll={true}

>
      {/* <MiniMap/> */}
      <Controls 
      showInteractive={false}
      />
      <Background variant="dots" color="royalblue" gap={10} /> 

    </ReactFlow>
    </div>
    );





  }  


  const waitFor = (milliseconds) =>{
    return new Promise((resolve) => setTimeout(resolve, milliseconds));
  }

   const inputChanged = (e) =>{
     const files = e.target.files
    var recData = null;
    var recFileName = null;
    setLoading(true)
     for (let i=0; i<files.length; i++) {
      console.log(files[i].webkitRelativePath)
      const reader = new FileReader(); 
      reader.onload = function(event){
        const data = event.target.result
        // console.log(data)  
        fileMap.set(files[i].name, data)
        if ( files[i].name == 'apps.json'){
          loadAppJSON(data)
        }
        else if (files[i].name.endsWith ('.rec'))
        {
            recFileName = files[i].name
            recData = data
            // loadModel(recFileName, recData)
          }
      }

      const urlReader = new FileReader(); 
      urlReader.onload = function(event){
        const data = event.target.result
        // console.log(data)  
        dataURLs.set(files[i].name, data)
        if (files[i].name == 'screenlast.png')
         {   
          waitFor(1000).then(()=>{
            loadModel(recFileName, recData)

          })
         }

      }



      if (files[i].name.endsWith(".png"))
       {
          reader.readAsArrayBuffer(files[i])
          urlReader.readAsDataURL(files[i])       }
      else
        reader.readAsText(files[i])
    };

      setLoading(false)

    // waitFor(1000).then(()=>{    
    //   setLoading(false)
    // })



   }

   

    const style = {
        // background: '#60d6f5',
        // background: '#52c9d0',
        // background:'#9eccdb',
        // background:'#bed6dd',
        width: '100%',
        height: 700
      };

      // if ( !submission.data)
      // return (
      //   <div>loading</div>
      // )
    
      return (
      <div>

      <div className="submissionCont">
        {/* <h2 style={{color:'slateblue', textAlign:'center'}}>{"Submission for task: " + submission.data.taskName + " by user: " + submission.data.userName}</h2> */}
            <input id='file-upload' style={{color: 'grey'}} directory="" webkitdirectory="" type="file" onChange={inputChanged}/>
        <br/>
        {/* <div style = {firstTime? {display:'flex'}: {display:'none'}}> */}
        {toolbar()}
        <h3 style={{textAlign:'center', fontSize:22, textDecoration: 'underline'}}>Task Recording Submission</h3>

        <div style = { {display:'flex'}}>
        <Loading loading ={loading}/>
        {/* <div style={firstTime? {display:'flex'}: {display:'none'}}> */}
        <div style={{display:'flex', textAlign:'center', fontSize:20}}>
        <h4 >1. Load your recording folder

        <LightTooltip title="Load Recording from local disk"> 
        <Button style={{backgroundColor:'royalblue' , border:'2px solid #c9e9f6', color:'white'}}  size="medium" startIcon={<BotLoadIcon />} onClick={clickInput}>
          Open Recording Folder
        </Button>
        </LightTooltip>

        </h4>

        {/* </div> */}

        {/* <div style={{display:'flex', flexDirection:'row'}}> */}

        <h4 >2. Add annotations to each screen after selecting each screen </h4>
        <h4 >3. Enter a number for times task is done per day </h4>


        <h4>4. Submit your recording         


        <LightTooltip title="Submit Recording to Cloud Storage"> 
        <Button style={{backgroundColor:'royalblue', border:'2px solid #c9e9f6', color:'white'}}  size="medium" startIcon={<CloudUploadIcon />} onClick={upload}>Submit Recording
        </Button>
        </LightTooltip>
        </h4>
        
        </div>

        </div>
        <div className="taskcard"  >            
          <div style = { (firstTime == true)? {display:'none'}: {display:'flex', flexDirection:'row'}}>
            <h3 style={{paddingLeft:'20px'}}>Total Time Taken: {secondsToMin(totalTime)} </h3>
            <h3 style={{paddingLeft:'20px'}}>Total Screens: {numScreens}</h3>
            <form className="taskform">  

            <h3>Number of times, task is performed per day <input id='timesaday' style={{width:40}} type='number' min='1' name='timesaday' number required></input></h3>
            
            </form>
            </div>
        </div>
        
        <Progress title={"Upload " + uploadStatus} visible = {showProgress} progress={progress} />

        <div className="designer">

            <ReactFlowProvider>

            <div className="reactflow-wrapper" ref={reactFlowWrapper}>

            {renderMain()}

            </div>
            <TaskAnnotations updateProperties = {updateProperties} element={selectedElement}>
                </TaskAnnotations>

            </ReactFlowProvider>

        </div>
        </div>
        </div>

      );
}
